module.exports = __webpack_public_path__ + "images/embed/filetypes/ppt.gif";